import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/auth";

export function ResetPasswordRequestPage() {
  const { requestPasswordReset, error } = useAuth();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await requestPasswordReset(email);
      setSent(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-sm mx-auto mt-16 p-4 rounded border bg-card">
      <h1 className="text-lg font-semibold mb-3">Reset password</h1>
      <form onSubmit={onSubmit} className="space-y-3">
        <div className="grid gap-1">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} required />
        </div>
        {error && (
          <div className="text-sm text-destructive">
            {import.meta.env.DEV ? error : "If that email exists, we’ve sent a reset link."}
          </div>
        )}
        <Button type="submit" disabled={submitting}>{submitting ? "Sending…" : "Send reset email"}</Button>
      </form>
      {sent && <div className="text-sm text-emerald-600 mt-2">If that email exists, we’ve sent a reset link.</div>}
    </div>
  );
}

export default ResetPasswordRequestPage;
